var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160496",
    "data-name": "Group 160496",
    transform: "translate(-30 -215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147642",
    "data-name": "Rectangle 147642",
    transform: "translate(30 215)",
    fill: "rgba(255,255,255,0.09)",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "paid_24dp_E8EAED_FILL0_wght200_GRAD-25_opsz24",
    d: "M136.057-819.077h.88v-1.111a3.98,3.98,0,0,0,1.955-.722,2.265,2.265,0,0,0,.948-2.013,2.506,2.506,0,0,0-.6-1.7,5.6,5.6,0,0,0-2.329-1.3,6.628,6.628,0,0,1-2.017-.952,1.472,1.472,0,0,1-.427-1.133,1.567,1.567,0,0,1,.574-1.233,2.253,2.253,0,0,1,1.529-.5,2.137,2.137,0,0,1,1.207.328,2.575,2.575,0,0,1,.8.844l.776-.313a3.071,3.071,0,0,0-.989-1.125,2.716,2.716,0,0,0-1.381-.5v-1.114H136.1v1.113a3.042,3.042,0,0,0-1.88.913,2.334,2.334,0,0,0-.638,1.582,2.146,2.146,0,0,0,.637,1.635,6.465,6.465,0,0,0,2.178,1.164,7.452,7.452,0,0,1,2.069,1.022,1.576,1.576,0,0,1,.524,1.263,1.587,1.587,0,0,1-.746,1.469,3,3,0,0,1-1.583.454,2.524,2.524,0,0,1-1.491-.476,3.283,3.283,0,0,1-1.075-1.354l-.787.336a3.777,3.777,0,0,0,1.1,1.5,4.151,4.151,0,0,0,1.646.757Zm.461-14.773Zm0,.887ZM136.519-825.347Z",
    transform: "translate(-95.074 1051.85)",
    fill: "#fff",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu2.4e8aafa29f42dc84e3a253e01ccb06f5.svg";
export { ForwardRef as ReactComponent };